import { useDemandeByIdQuery } from "../../stores/OkOkStore";
import { useParams } from "react-router";
import DemandeEditComponent  from "../../components/Demandes/DemandeEditComponent";
import { useTrads } from "../../contexts/trads/useTrads";

function DemandeEdit() {
    const params = useParams();
    const { data: demande, error, isLoading } = useDemandeByIdQuery(params.demandeId??"0");

    const {translate}=useTrads();

  return (

        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
           <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>

        ) : demande ? (
                <>
                <h2>{translate('title_edit_demande')}</h2>
                <DemandeEditComponent demandeParam={demande}  />
                </>
        ):null
  );
}
export default DemandeEdit;